var path = '/modules/messages/views/pages/sms/list.tpl.html';
var html = "<listview store=\"vm.store\"></listview>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/messages/views/pages/sms/list.tpl.html
// module id = 2142
// module chunks = 1